module.exports = __webpack_public_path__ + "static/media/ibfe-online.47d3a3ad.svg";